<template>
  <div>
    <div class="cominfo-header">企业中心
      <span>/</span><span>培训中心</span><span>/</span><span @click="goBack()">
        题库
      </span><span>/</span><span>{{ruleForm.id?(disabled?'查看':'编辑'):'新建'}}试题</span>
    </div>
    <div class="comUserInfo" v-loading="loading">
      <div class="comUserInfo-header">
        <el-button type="primary" v-if="!disabled" @click="onSave">保存</el-button>
        <el-button type="primary" v-if="disabled" @click="goBack">返回</el-button>
      </div>
      <div class="comUserInfo-conts">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
          style="width: 773px;margin: 20px 0px 20px 100px;text-align: left;padding-bottom: 50px;">
          <el-form-item label="分类：" prop="parentid">
            <el-select :disabled="disabled" @change="getParName" v-model="ruleForm.parentid" placeholder="请选择分类"
              style="width: 100%;">
              <el-option-group v-for="group in options" :key="group.uniqueCode" :label="group.text"
                style="width: 100%;">
                <el-option v-for="item in group.children" :key="item.uniqueCode" :label="item.text"
                  :value="item.uniqueCode">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="难度：" prop="clevel">
            <el-select :disabled="disabled" v-model="ruleForm.clevel" placeholder="请选择难度类型" style="width: 100%;">
              <el-option v-for="item in clevel" :key="item.val" :label="item.text" :value="item.val"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="题型：" prop="itype">
            <el-select :disabled="disabled" v-model="ruleForm.itype" placeholder="请选择题型" style="width: 100%;">
              <el-option v-for="item in itype" :key="item.val" :label="item.text" :value="item.val"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="题目：" prop="cname">
            <el-input :disabled="disabled" v-model="ruleForm.cname" placeholder="请输入题目"></el-input>
          </el-form-item>

          <el-form-item prop="dalists" v-if="ruleForm.itype!='3'" :key="i" v-for="(item,i) in dalists"
            :label="'选项'+(i+1)+'：'">
            <el-input :disabled="disabled" v-if="i<3" :placeholder="'请输入选项'+(i+1)+'内容'" v-model="item.conts"></el-input>
            <el-input v-else :disabled="disabled" :placeholder="'请输入选项'+(i+1)+'内容'" v-model="item.conts">
              <i slot="suffix" class="el-input__icon el-icon-delete-solid" @click="delXx(i)"
                style="cursor: pointer;"></i>
            </el-input>
          </el-form-item>
          <el-form-item v-if="ruleForm.itype!='3'&&!disabled">
            <el-button type="primary" plain @click="addXx()">添加选项</el-button>
          </el-form-item>


          <el-form-item label="试题答案：" v-if="ruleForm.itype=='1'"
            :rules="[{ required: true, message: '试题答案不能为空', trigger: 'blur' }]">
            <el-radio-group v-model="ruleForm.stda" :disabled="disabled">
              <el-radio v-for="(item,i) in dalists" :key="i" :label="i" :value="i">{{'选项'+(i+1)}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="试题答案：" v-if="ruleForm.itype=='2'"
            :rules="[{ required: true, message: '试题答案不能为空', trigger: 'blur' }]">
            <el-checkbox-group v-model="ruleForm.stdaArr" :disabled="disabled">
              <el-checkbox v-for="(item,i) in dalists" :key="i" :label="i" :value="i">{{'选项'+(i+1)}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="试题答案：" v-if="ruleForm.itype=='3'"
            :rules="[{ required: true, message: '试题答案不能为空', trigger: 'blur' }]">
            <el-radio-group v-model="ruleForm.stda" :disabled="disabled">
              <el-radio v-for="(item,i) in 2" :key="i" :label="i" :value="i">{{i==1?'对':'错'}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="试题解析：" prop="description">
            <el-input type="textarea" :disabled="disabled" :rows="2" placeholder="请输入试题解析"
              v-model="ruleForm.description">
            </el-input>
          </el-form-item>
          <el-form-item label="状态：" prop="state">
            <el-radio-group v-model="ruleForm.state">
              <el-radio :disabled="disabled" v-for="(k,i) in 2" :label="i" :value="i" :key="i">{{i==0?'不生效':'生效'}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getItype
  } from '@/assets/js/common.js';
  export default {
    props: ['collapse', 'wjSrc', 'currentUser'],
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('联系方式不能为空！'));
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('联系方式有误，请重新输入！'));
        } else {
          callback();
        }
      };
      return {
        rules: {
          cname: [{
            required: true,
            message: '题目不能为空',
            trigger: 'blur'
          }],
          parentid: [{
            required: true,
            message: '类型不能为空',
            trigger: 'blur'
          }],
          clevel: [{
            required: true,
            message: '难度不能为空',
            trigger: 'blur'
          }],
          itype: [{
            required: true,
            message: '题型不能为空',
            trigger: 'blur'
          }],
          description: [{
            required: true,
            message: '试题解析不能为空',
            trigger: 'blur'
          }],
          state: [{
            required: true,
            message: '状态不能为空',
            trigger: 'blur'
          }],
          dalists: [{
            required: true,
            message: '选项内容不能为空',
            trigger: 'blur'
          }]
        },
        ruleForm: {
          dalists: "[]",
          stda: '',
          stdaArr: [],
          cid: '',
          description: "暂无",
          state:1
        },
        dalists: [{
          conts: "",
          iscorrect: 0
        }, {
          conts: "",
          iscorrect: 0
        }, {
          conts: "",
          iscorrect: 0
        }],
        options: [],
        loading: false,
        itype: [{
          val: 1,
          text: '单选'
        }, {
          val: 2,
          text: '多选'
        }, {
          val: 3,
          text: '判断'
        }],
        clevel: [{
          val: 1,
          text: '简单'
        }, {
          val: 2,
          text: '一般'
        }, {
          val: 3,
          text: '困难'
        }],
        disabled: false
      }
    },
    methods: {
      onSave: function() {
        var $this = this;
        this.loading = true;
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            var url = '/kt/ktQuestions/add.htm'
            if (this.ruleForm.id) {
              url = '/kt/ktQuestions/update.htm';
            }
            if (this.ruleForm.itype == '1') {
              this.dalists.map((item, k) => {
                k == this.ruleForm.stda ? this.dalists[k].iscorrect = '1' : this.dalists[k].iscorrect = '0';
                this.dalists[k].order = Number(k) + 1;
              })
            } else if (this.ruleForm.itype == '2') {
              this.dalists.map((item, k) => {
                this.ruleForm.stdaArr.indexOf(k) >= 0 ? this.dalists[k].iscorrect = '1' : this.dalists[k]
                  .iscorrect = '0';
                this.dalists[k].order = Number(k) + 1;
              })
            } else if (this.ruleForm.itype == '3') {
              this.dalists = [{
                iscorrect: this.ruleForm.stda,
                order: 1
              }]
            }
            this.$set(this.ruleForm, 'dalists', JSON.stringify(this.dalists));

            delete this.ruleForm.stda;
            delete this.ruleForm.stdaArr;
            this.ruleForm.state=1;
            // return;
            this.$axios.post(url, this.$qs.stringify(this.ruleForm))
              .then(res => {
                var data = res.data;
                this.loading = false;
                if (data.stat == '1') {
                  this.$message({
                    message: '试题保存成功！',
                    type: 'success',
                    duration: 1000,
                    onClose: function() {
                      $this.$router.push('/Company/Enterprise');
                    }
                  });
                } else {
                  this.$message.error(data.message);
                }
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      goBack: function() {
        this.$router.go(-1);
      },
      getData: function(id) {
        this.$axios.get('/kt/ktQuestions/detail.htm?id=' + id).then(res => {
          var data = res.data;
          this.loading = false;
          if (data.stat == '1') {
            data.data.dalists = "[]"
            this.ruleForm = data.data;
            this.dalists = data.data.dalist;
            delete this.ruleForm.dalist;
            if (data.data.itype == "1") {
              this.dalists.map((item, i) => {
                if (item.iscorrect == '1') {
                  this.$set(this.ruleForm, 'stda', i);
                }
              })
            } else if (data.data.itype == "2") {
              var arr = [];
              this.dalists.map((item, i) => {
                if (item.iscorrect == '1') {
                  arr.push(i)
                }
              });
              this.$set(this.ruleForm, 'stdaArr', arr);
            } else if (data.data.itype == "3") {
              this.$set(this.ruleForm, 'stda', this.dalists[0].iscorrect);
            }
          } else {
            this.$message.error(data.message);
          }
        })
      },
      // 获取培训类别名称
      getParName: function(val) {
        var list = [];
        if (val.indexOf('ZXKT_producttype_2') >= 0) {
          list = this.options[0].children
        } else {
          list = this.options[1].children
        };
        list.map((item) => {
          if (item.uniqueCode == val) {
            this.$set(this.ruleForm, 'parentname', item.text);
          }
        });
      },
      // 添加选项
      addXx: function() {
        this.dalists.push({
          conts: "",
          iscorrect: 0
        });
      },
      // 删除某个选项
      delXx: function(i) {
        this.dalists.splice(i, 1);
      }
    },
    created: function() {
      // 人员详情
      if (this.$route.query.id) {
        this.loading = true;
        this.disabled = this.$route.query.isck == '1'
        this.getData(this.$route.query.id);

      };
      getItype(this.$axios, ((res) => {
        this.options = res;
      }));
      // 滚动条滚动到最顶部
      $('#app').animate({
        scrollTop: 110
      }, 300);

      this.$set(this.ruleForm, 'cid', this.currentUser.cid);
    },
    components: {}
  }
</script>
<style>
  .comUserInfo {
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 20px;
  }

  .comUserInfo-header {
    height: 70px;
    border-bottom: 1px solid #efefef;
    padding: 0 30px;
    text-align: right;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
  }

  .avatar {
    width: 100px;
    height: 140px;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/Addprice.vue